export class VerificationModel {
  constructor(
    public readonly isSuccess: boolean,
    public email?: string,
    public sc?: string
  ){}
}
